var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block-actions"
    },
    [
      _c("studip-action-menu", {
        attrs: {
          items: _vm.menuItems,
          context: _vm.block.attributes.title
        },
        on: {
          editBlock: _vm.editBlock,
          setVisibility: _vm.setVisibility,
          showInfo: _vm.showInfo,
          deleteBlock: _vm.deleteBlock,
          removeLock: _vm.removeLock
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }